module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10050.ecd1bfb4.jpg";